/* Bonorum Setup-Finder – v10
   Neu: „Alle in den Warenkorb“, Kontaktformular mit vorausgefüllter Anfrage, Hinweise einklappbar. */
(() => {
  if (customElements.get('bn-setup-finder')) return;

  class BonorumFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const init = () => {
        if (this.ready) return;
        this.ready = true;
        this.text = JSON.parse(this.querySelector('[data-finder-text]').textContent);
        this.form = this.querySelector('.bn-finder__form');
        this.result = this.querySelector('.bn-finder__result');
        this.contactBlock = this.querySelector('[data-contact-block]');
        this.addAllButton = this.querySelector('[data-add-all]');
        this.status = this.querySelector('[data-status]');

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          if (this.form.reportValidity()) this.show();
        });
        this.form.addEventListener('change', () => {
          this.result.hidden = true;
          if (this.contactBlock && !this.querySelector('[data-success]')) this.contactBlock.hidden = true;
        });
        if (this.addAllButton) this.addAllButton.addEventListener('click', () => this.addAll());

        // Nach dem Absenden des Kontaktformulars lädt Shopify die Seite neu: Bestätigung sichtbar machen.
        const success = this.querySelector('[data-success]');
        const errors = this.querySelector('.bn-finder__errors');
        if ((success || errors) && this.contactBlock) {
          this.contactBlock.hidden = false;
          const target = success || errors;
          target.scrollIntoView({ block: 'center' });
          if (success) success.focus({ preventScroll: true });
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
      else init();
    }

    show() {
      const d = new FormData(this.form);
      const n = Number(d.get('plants'));
      const goal = d.get('goal');
      const sub = d.get('substrate');
      const area = d.get('area');
      const density = area === '100' && n > 9;
      const t = this.text;
      const notes = [];
      const roles = new Set([d.get('nutrients')]);
      const add = (k) => notes.push(t[k]);

      let consult = density || area === 'other' || n > 12 || d.get('zones') !== 'one' || d.has('foreign') ||
        goal === 'precision' || (sub === 'rockwool' && goal !== 'precision') || d.has('have_drip');

      if (density) add('density_note');
      if (['60', '80', '100', '120', '60120'].includes(area)) {
        roles.add('table' + area);
        add('table_note');
        if (area === '100') add('table100_note');
      } else add('table_pending');
      add(sub === 'soil' ? 'table_optional' : 'table_coco');

      if (!density && !d.has('have_drip') && n <= 12 && d.get('zones') === 'one' && !d.has('foreign')) {
        roles.add(n <= 3 ? 'set3' : n <= 6 ? 'set6' : n <= 9 ? 'set9' : 'set12');
      }
      if (d.has('have_drip')) add('existing_note');
      if (n > 12 && n <= 20) add('extension');
      if (n > 20 || d.get('zones') !== 'one') add('large');
      if (d.has('foreign')) add('foreign_note');

      if (goal === 'light') {
        roles.add('ac_bundle');
        if (!d.has('have_ai')) roles.add('ac_controller');
        else add('have_ai_note');
        add('bundle_guide');
      } else if (goal === 'precision') {
        roles.add('growlink'); roles.add('valve'); roles.add('guide_growlink');
      } else roles.add('guide_light');

      if (sub === 'coco' || sub === 'undecided') {
        roles.add('quickfill'); roles.add('plagron');
        add(sub === 'coco' ? 'coco_note' : 'undecided_note');
        if (sub === 'undecided' && goal === 'precision') roles.add('rockwool');
        add('drain_note');
      }
      if (sub === 'soil') { add('soil_note'); roles.add('quickfill'); roles.add('plagron'); }
      if (sub === 'rockwool') {
        if (goal === 'precision') { roles.add('rockwool'); add('rock_note'); }
        else add('rock_consult');
      }
      add(d.get('nutrients') === 'pro' ? 'pro_note' : 'blended_note');
      add('excluded');
      add('guide_note');

      let missing = false;
      roles.forEach((role) => { if (!this.querySelector('[data-role="' + role + '"]')) missing = true; });
      if (missing) { consult = true; add('missing'); }

      this.querySelectorAll('[data-role]').forEach((card) => { card.hidden = !roles.has(card.dataset.role); });

      const summary = t[goal === 'precision' ? 'precision_text' : goal === 'light' ? 'light_text' : 'basic_text'] + ' ' + t[consult ? 'consult' : 'standard'];
      this.querySelector('[data-summary]').textContent = summary;

      const list = this.querySelector('[data-notes]');
      list.replaceChildren();
      notes.forEach((note) => { const li = document.createElement('li'); li.textContent = note; list.append(li); });
      const count = this.querySelector('[data-notes-count]');
      if (count) count.textContent = '(' + notes.length + ')';

      // Warenkorb-Button: nur bei Standard-Setups (keine individuelle Planung nötig),
      // nur verfügbare Produkte, ohne Substrat-Alternativen und Planungsbeispiele.
      const visible = this.visibleCards();
      const buyable = this.buyableCards();
      const skipped = visible.some((c) => BonorumFinder.NOT_IN_BUNDLE.includes(c.dataset.role));
      const unavailable = visible.some((c) => c.dataset.available !== 'true' && !BonorumFinder.NOT_IN_BUNDLE.includes(c.dataset.role));
      if (this.addAllButton) {
        this.addAllButton.hidden = consult || buyable.length === 0;
        this.addAllButton.disabled = false;
      }
      const messages = [];
      if (!consult) {
        if (buyable.length === 0) messages.push(t.none_available);
        else {
          if (unavailable) messages.push(t.partly_available);
          if (skipped) messages.push(t.substrate_hint);
        }
      }
      this.setStatus(messages.join(' '));

      // Anfrage-Text für Kontaktformular (vollständig) und E-Mail-Link (kurz, damit nichts abgeschnitten wird)
      const q = (s) => String(s).replace(/\?\s*$/, '');
      const labels = [
        q(t.goal) + ': ' + t[goal], q(t.plants) + ': ' + n, q(t.area) + ': ' + t['area' + area],
        q(t.substrate) + ': ' + t[sub], q(t.zones) + ': ' + t[d.get('zones')], q(t.nutrients) + ': ' + t[d.get('nutrients')],
        ...['have_drip', 'have_ai', 'foreign'].filter((k) => d.has(k)).map((k) => t[k])
      ];
      const products = visible.map((c) => '• ' + c.querySelector('h5').textContent.trim() + ' – ' + c.querySelector('a').href);
      const fullBody = labels.join('\n') + '\n\n' + summary + '\n\n' + products.join('\n');
      const body = this.querySelector('[data-contact-body]');
      if (body) body.value = fullBody;
      const mail = this.querySelector('[data-contact]');
      if (mail) {
        const shortBody = labels.join('\n') + '\n\n' + visible.map((c) => '• ' + c.querySelector('h5').textContent.trim()).join('\n');
        mail.href = 'mailto:' + this.dataset.email + '?subject=' + encodeURIComponent(t.email_subject) + '&body=' + encodeURIComponent(shortBody);
      }

      this.result.hidden = false;
      if (this.contactBlock) this.contactBlock.hidden = false;
      const title = this.querySelector('[data-result-title]');
      title.focus({ preventScroll: true });
      title.scrollIntoView({ block: 'start', behavior: 'auto' });
    }

    visibleCards() {
      return [...this.querySelectorAll('[data-role]')].filter((c) => !c.hidden);
    }

    buyableCards() {
      return this.visibleCards().filter((c) => c.dataset.available === 'true' && c.dataset.variant &&
        !BonorumFinder.NOT_IN_BUNDLE.includes(c.dataset.role));
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message || '';
    }

    async addAll() {
      const t = this.text;
      const ids = [...new Set(this.buyableCards().map((c) => Number(c.dataset.variant)))];
      if (!ids.length) { this.setStatus(t.none_available); return; }

      const button = this.addAllButton;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      this.setStatus(t.adding);

      // Gleiche Bereiche aktualisieren wie der Theme-eigene Warenkorb-Button (Header-Zähler + Warenkorb-Drawer)
      const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el && el.dataset.sectionId);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: ids.map((id) => ({ id, quantity: 1 })),
            sections: sectionsToUpdate.map((el) => el.dataset.sectionId).join(','),
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || response.status);

        this.setStatus(t.added);
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantIds: ids } }));

        // Live-Shop nutzt die App UpCart als Warenkorb-Drawer: dann deren offizielle API verwenden
        // (https://aftersell.mintlify.app/upcart/common_upcart_api_uses) statt des Theme-Drawers.
        if (typeof window.upcartOpenCart === 'function') {
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          window.upcartOpenCart();
          return;
        }

        const settings = (window.theme && window.theme.settings) || {};
        if (settings.afterAddToCart === 'page' || !data.sections) {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || root + 'cart';
          return;
        }
        sectionsToUpdate.forEach((el) => {
          const html = data.sections[el.dataset.sectionId];
          if (html && typeof el.updateFromCartChange === 'function') el.updateFromCartChange(html);
        });
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = root + 'cart';
      } catch (error) {
        console.warn('Bonorum Setup-Finder:', error); // eslint-disable-line no-console
        this.setStatus(t.add_error);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  // Substrate sind Alternativen und hängen von der Pflanzenzahl ab; das Magnetventil ist nur ein Planungsbeispiel.
  BonorumFinder.NOT_IN_BUNDLE = ['quickfill', 'plagron', 'rockwool', 'valve'];

  customElements.define('bn-setup-finder', BonorumFinder);
})();
